export const LEARN_MORE_ABOUT_NUDGING =
  'https://konflux-ci.dev/docs/building/component-nudges/#customizing-nudging-prs';
export const LEARN_MORE_GITLAB_OR_FORGEJO_URL =
  'https://konflux-ci.dev/docs/building/secrets/creating-scm-secrets/';
export const LEARN_MORE_SNAPSHOTS = 'https://konflux-ci.dev/docs/testing/integration/snapshots/';
export const LEARN_MORE_GITLAB_URL =
  'https://konflux-ci.dev/docs/building/creating-gitlab/#creating-a-gitlab-access-token-and-secret';
export const LEARN_MORE_FORGEJO_URL =
  'https://konflux-ci.dev/docs/building/creating-forgejo/#creating-a-forgejo-access-token-and-secret';
export const GETTING_ACCESS_INTERNAL =
  'https://konflux.pages.redhat.com/docs/users/getting-started/getting-access-new.html';
export const LEARN_MORE_ABOUT_INTEGRATION_TESTS =
  'https://konflux-ci.dev/docs/testing/integration/';
export const INTERNAL_DOCUMENTATION_BASE_URL = 'https://konflux.pages.redhat.com/docs/users/';
export const EXTERNAL_DOCUMENTATION_BASE_URL = 'https://konflux-ci.dev/docs/';
export const LEARN_MORE_ABOUT_SECRETS_CREATION = 'https://konflux-ci.dev/docs/building/secrets/';
export const LEARN_MORE_ABOUT_CREATING_APPLICATIONS =
  'https://konflux-ci.dev/docs/building/creating/';
export const LEARN_MORE_ABOUT_COMPONENTS = 'https://konflux-ci.dev/docs/building/creating/'; // Duplicate for readability
export const CONFORMA_POLICY_URL = 'https://conforma.dev/docs/policy/release_policy.html';
export const CONFORMA_POLICY_AVAILABLE_RULE_COLLECTIONS_URL = `${CONFORMA_POLICY_URL}#_available_rule_collections`;
export const LEARN_MORE_ABOUT_LOGIN_IMAGE_REPO =
  'https://konflux-ci.dev/docs/building/accessing-private-images';
